export const OFFER_PARTNER_ELIGIBILITY_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.PartnerEligibilityUpdated";
export const OFFER_PARTNER_ELIGIBILITY_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.PartnerEligibilityInvalidated";
